export const INDIGITALL_URL = '/';

export const CHANNELS = {
  whatsapp: 'whatsapp',
  webchat: 'webchat',
}